import { graphql } from 'react-relay';

export const checkedCanSurveyQuery = graphql`
  query initCheckedCanSurveyQuery($refundHistoryId: String!) {
    getSurveyStatus(refundHistoryId: $refundHistoryId) {
      result
      errors {
        code
        message
      }
      surveyStatus {
        surveyAnswerId
      }
    }
  }
`;

export const refundHistoryIdQuery = graphql`
  query initSurveyRefundHistoryIdQuery {
    getRefundHistoryId {
      result
      refundHistoryId
    }
  }
`;

export const surveyInitQuery = graphql`
  query initSurveyQuery($refundHistoryId: String!) {
    bznavRefund {
      imputedYear {
        indis
      }
    }
    getSurveyStatus(refundHistoryId: $refundHistoryId) {
      result
      errors {
        code
        message
      }
      surveyStatus {
        surveyAnswerId
        totalAmount
        txprNm
        isCompleted
        deductionTypes
        expiredAt
      }
    }
    getSurveyBusinessInfo(refundHistoryId: $refundHistoryId) {
      business {
        bmanTin
        totalAmount
      }
    }
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId) {
      businessAnswer {
        bmanTin
        isCompleted
      }
    }
    getSurveyEmployees(refundHistoryId: $refundHistoryId) {
      result
      employees {
        indvTin
        ieNm
        birthday
        attrYears
      }
    }
  }
`;

export const surveyHomeQuery = graphql`
  query initialSurveyHomeQuery($refundHistoryId: String!) {
    getSurveyStatus(refundHistoryId: $refundHistoryId) {
      surveyStatus {
        totalAmount
      }
    }
    getSurveyBusinessInfo(refundHistoryId: $refundHistoryId) {
      result
      business {
        bmanTin
        tfbDtcsNm
        tnm
        bsno
        totalAmount
      }
    }
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId) {
      businessAnswer {
        bmanTin
        isCompleted
      }
    }
  }
`;
